import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static targets = ['info']

  declare readonly infoTargets: HTMLSpanElement[]

  #selectParcels(): void {
    const key = 'autoSelectable'
    this.infoTargets.forEach(infoTarget => {
      const shouldCheck = infoTarget.dataset[key] === 'true'
      const tRow = infoTarget.parentElement?.parentElement?.parentElement
      const checkboxRaw = tRow?.querySelector('input[type="checkbox"]')
      if (checkboxRaw !== null && typeof checkboxRaw !== 'undefined') {
        const checkbox = checkboxRaw as HTMLInputElement
        if (checkbox.checked && shouldCheck) return
        if (!checkbox.checked && !shouldCheck) return
        checkbox.click()
      }
    })
  }

  autoSelectParcels(e: MouseEvent): void {
    e.preventDefault()
    this.#selectParcels()
  }
}
